import { Log, Level, Logger } from 'ng2-logger';
import Types, { IAppState, GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/profile';
import { ISetProfile, IChangePasswordSet, IChangePasswordQuestionSet, IUpdateProfilePhotoSet, ISetPreferences, ISetTimezone } from '../../models/action/profile';

const _logger = Log.create('Profile Reducer');

const profileReducer = (state = GlobalState().profile, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };
    if (action.type === Actions.actions.SET_PROFILE) {
        const profilePageAction = (action as ISetProfile);
        newState.profileData = profilePageAction.profileData;
    } else if (action.type === Actions.actions.CHANGE_PASSWORD_SET) {
        const changePasswordData = (action as IChangePasswordSet);
        newState.isChangePassword = changePasswordData.isChangePassword;
    } else if (action.type === Actions.actions.CHANGE_PASSWORD_QUESTION_SET) {
        const changePasswordQuestionData = (action as IChangePasswordQuestionSet);
        newState.isChangePasswordQuestion = changePasswordQuestionData.isChangePasswordQuestion;
    } else if (action.type === Actions.actions.UPDATE_PROFILE_PHOTO_ACTION_SET) {
        const updateProfilePhotoData = (action as IUpdateProfilePhotoSet);
        newState.isProfilePhotoUpload = updateProfilePhotoData.profilePhotoData.isProfilePhotoUpload;
        newState.photoKey = updateProfilePhotoData.profilePhotoData.photoKey;
    } else if (action.type === Actions.actions.USER_PREFERENCES_SET) {
        const userPreferencesData = (action as ISetPreferences);
        newState.userPreferences = userPreferencesData;
    } else if (action.type === Actions.actions.SET_TIMEZONE) {
        const timezonePageAction = (action as ISetTimezone);
        newState.timezoneData = timezonePageAction.timezoneData;
    } else {
        return state;
    }
    return Object.assign({}, state, newState);
};

export default profileReducer;